module.exports = __webpack_public_path__ + "img/logo_police.d0289dc0.png";